{
  "common": {
    "loading": "Yuklanmoqda...",
    "not_found": "Topilmadi",
    "back": "← Orqaga",
    "add_to_cart": "Savatga",
    "added": "Qo'shildi ✓",
    "remove": "O'chirish",
    "save": "Saqlash",
    "cancel": "Bekor qilish",
    "confirm": "Tasdiqlash",
    "search": "Qidirish",
    "clear": "Tozalash",
    "error": "Xatolik",
    "yes": "Ha",
    "no": "Yo'q"
  },
  "nav": {
    "home": "Bosh sahifa",
    "favorites": "Sevimlilar",
    "cart": "Savat",
    "profile": "Profil"
  },
  "cart": {
    "title": "Savat",
    "empty": "Hozircha bo'sh.",
    "empty_hint": "Katalogdan mahsulot qo'shing",
    "go_to_catalog": "Katalogga o'tish",
    "size_word": "o'lcham",
    "increase": "Ko'paytirish",
    "decrease": "Kamaytirish"
  },
  "favorites": {
    "title": "Sevimlilar",
    "empty": "Hozircha bo'sh.",
    "empty_hint": "Mahsulotlarni keyinroq qaytish uchun qo'shing",
    "go_to_catalog": "Katalogga o'tish",
    "recommendations": "Sizga yoqishi mumkin",
    "aria_add": "Sevimlilarga qo'shish",
    "aria_remove": "Sevimlilardan olib tashlash"
  },
  "product": {
    "not_found": "Mahsulot topilmadi",
    "article": "Artikul",
    "country": "Mamlakat",
    "composition": "Tarkibi",
    "color": "Rang",
    "size": "O'lcham",
    "stock": "Qoldiq: {count} dona.",
    "description": "Tavsif",
    "view_image": "{n}-foto",
    "delivery_estimate": "Yetkazib berish 7–14 kun"
  },
  "badges": {
    "original": "Original",
    "in-stock": "Sotuvda",
    "new": "Yangi",
    "hit": "Xit",
    "sale": "Chegirma",
    "exclusive": "Eksklyuziv"
  },
  "catalog": {
    "search_placeholder": "Katalogdan qidirish",
    "all": "Hammasi",
    "category": "Kategoriya",
    "brand": "Brend",
    "color": "Rang",
    "size": "O'lcham",
    "sort": "Tartiblash",
    "sort_newest": "Avval yangilari",
    "sort_price_asc": "Avval arzonlari",
    "sort_price_desc": "Avval qimmatlari",
    "all_categories": "Barcha kategoriyalar",
    "all_brands": "Barcha brendlar",
    "all_colors": "Barcha ranglar",
    "all_sizes": "Barcha o'lchamlar",
    "empty": "Hech narsa topilmadi",
    "error": "Katalogni yuklashda xatolik",
    "count": "{count} ta mahsulot",
    "all_products": "Barcha mahsulotlar",
    "in_stock": "Mavjud",
    "foreign": "Original",
    "filter": "Filtrlash",
    "reset_filters": "Filtrlarni tozalash"
  },
  "admin": {
    "title": "Admin panel",
    "no_access": "Ruxsat yo'q",
    "add": "Qo'shish",
    "edit": "Tahrirlash",
    "save": "Saqlash",
    "delete": "O'chirish",
    "ban": "Bloklash",
    "unban": "Blokdan chiqarish",
    "saved": "Saqlandi",
    "deleted": "O'chirildi",
    "empty": "Bo'sh",
    "on": "Yoq",
    "off": "O'chiq",
    "f_title": "Sarlavha",
    "f_subtitle": "Quyi sarlavha",
    "f_image": "Rasm URL",
    "f_position": "Pozitsiya",
    "f_active": "Faol",
    "f_name": "Nomi",
    "f_address": "Manzil",
    "f_city": "Shahar",
    "f_phone": "Telefon",
    "f_lat": "Kenglik",
    "f_lng": "Uzunlik",
    "f_slug": "Slug",
    "f_main": "Asosiy",
    "f_sort": "Tartib",
    "f_kind": "Turi",
    "dict_size": "O'lchamlar",
    "dict_color": "Ranglar",
    "dict_brand": "Brendlar",
    "dict_badge": "Bedjlar",
    "f_hex": "Rang (hex)",
    "f_article": "Artikul",
    "f_price": "Narx",
    "f_oldprice": "Eski narx",
    "f_badge": "Bedj",
    "f_status": "Status",
    "a_orders": "Buyurtmalar",
    "a_revenue": "Daromad",
    "a_users": "Foydalanuvchilar",
    "a_products": "Mahsulotlar",
    "a_visits": "Tashriflar",
    "a_by_status": "Status bo'yicha",
    "sec_orders": "Buyurtmalar",
    "sec_catalog": "Katalog",
    "sec_marketing": "Marketing",
    "sec_system": "Tizim",
    "mod_orders": "Buyurtmalar",
    "mod_orders_hint": "Barcha buyurtmalar va status",
    "mod_returns": "Qaytarishlar",
    "mod_returns_hint": "Tovarni qaytarish arizalari",
    "mod_promotions": "Aksiyalar",
    "mod_promotions_hint": "Chegirmalar va bonuslar",
    "mod_campaigns": "Tarqatmalar",
    "mod_campaigns_hint": "Mijozlarga yangiliklar va aksiyalar",
    "camp_new": "+ Yangi tarqatma",
    "camp_empty": "Hozircha tarqatmalar yo'q",
    "camp_f_title": "Nomi (ichki)",
    "camp_f_body": "Xabar matni",
    "camp_f_image": "Rasm (URL, ixtiyoriy)",
    "camp_f_target": "Tugma o'tishi",
    "camp_f_pick": "Qayerga",
    "camp_f_button": "Tugma matni",
    "camp_btn_ph": "Ochish",
    "camp_f_audience": "Auditoriya",
    "camp_target_none": "Tugmasiz",
    "camp_target_product": "Tovarga",
    "camp_target_category": "Kategoriyaga",
    "camp_aud_all": "Hammasi",
    "camp_send": "📣 Tarqatmani yuborish",
    "camp_sending": "Yuborilmoqda…",
    "camp_sent": "Yuborildi: {{sent}}, xato: {{failed}}",
    "camp_stats": "Yuborildi: {{sent}} · xato: {{failed}}",
    "camp_save_first": "Avval saqlang, keyin yuborish tugmasi paydo bo'ladi",
    "camp_status_draft": "Qoralama",
    "camp_status_sending": "Yuborilmoqda",
    "camp_status_done": "Yuborilgan",
    "cancel": "Bekor qilish",
    "promo_new": "+ Yangi aksiya",
    "promo_empty": "Hozircha aksiyalar yo'q",
    "promo_inactive": "O'chiq",
    "promo_pick_product": "Tovarni tanlang",
    "promo_type_cart_total": "Summadan chegirma",
    "promo_type_day": "Hafta kuni chegirmasi",
    "promo_type_product_buy": "Tovar xaridida chegirma",
    "promo_type_bonus_item": "Bonus tovar",
    "promo_reward_percent": "Foiz %",
    "promo_reward_fixed": "Summa",
    "promo_f_title": "Nomi",
    "promo_f_code": "Promokod (bo'sh = avto)",
    "promo_code_ph": "masalan SALE10 (bo'sh — hammaga)",
    "promo_f_type": "Aksiya turi",
    "promo_f_min_total": "Savat summasi dan",
    "promo_f_min_total_opt": "Min. summa (ixtiyoriy)",
    "promo_f_weekdays": "Hafta kunlari",
    "promo_f_trigger_product": "Trigger tovar",
    "promo_f_min_qty": "Min. miqdor",
    "promo_f_reward_kind": "Chegirma",
    "promo_f_reward_value": "Qiymat",
    "promo_f_bonus_product": "Bonus tovar",
    "promo_f_bonus_name": "Bonus nomi",
    "promo_f_bonus_qty": "Bonus soni",
    "promo_f_starts": "Boshlanishi",
    "promo_f_ends": "Tugashi",
    "promo_f_priority": "Ustuvorlik",
    "promo_f_active": "Faol",
    "promo_f_stackable": "Yig'iladi",
    "wd_0": "Yak",
    "wd_1": "Du",
    "wd_2": "Se",
    "wd_3": "Cho",
    "wd_4": "Pa",
    "wd_5": "Ju",
    "wd_6": "Sha",
    "returns_empty": "Qaytarish arizalari yo'q",
    "mod_banners": "Bannerlar",
    "mod_banners_hint": "Bosh sahifadagi promo-bannerlar",
    "mod_pickup": "Olib ketish punktlari",
    "mod_pickup_hint": "O'zi olib ketish nuqtalari",
    "mod_categories": "Kategoriyalar",
    "mod_categories_hint": "Katalog kategoriyalari",
    "mod_dictionary": "Ma'lumotnomalar",
    "mod_dictionary_hint": "O'lcham, rang, brend, bedjlar",
    "mod_products": "Mahsulotlar",
    "mod_products_hint": "Mahsulotlar va narxlar",
    "mod_settings": "Sozlamalar",
    "mod_settings_hint": "Kontaktlar, yetkazib berish, rekvizitlar",
    "mod_users": "Foydalanuvchilar",
    "mod_users_hint": "Rollar va bloklash",
    "mod_analytics": "Analitika",
    "mod_analytics_hint": "Buyurtmalar, daromad, tashriflar",
    "no_orders": "Hozircha buyurtma yo'q",
    "customer": "Mijoz",
    "change_status": "Status",
    "status_updated": "Status yangilandi",
    "courier": "Kuryer",
    "courier_none": "Kuryersiz",
    "courier_assigned": "Kuryer tayinlandi",
    "car_model": "Model",
    "car_color": "Rang",
    "car_plate": "Raqam",
    "fulfill_title": "Yetkazishni belgilash",
    "fulfill": "Yetkazishni tasdiqlash",
    "fulfilling": "Saqlanmoqda…",
    "fulfill_hint": "Haqiqatda topshirilgan miqdorni kiriting. Yetkazilmagani omborga qaytadi, summa qayta hisoblanadi.",
    "fulfill_locked": "Faqat «Yig'ilgan» / «Yetkazilmoqda» holatlari uchun.",
    "ordered_q": "buyurtma",
    "mark_delivery": "Yetkazishni belgilash",
    "photos": "Rasmlar",
    "photos_title": "Mahsulot rasmlari",
    "photos_upload": "+ Rasm yuklash",
    "photos_uploading": "Yuklanmoqda…",
    "photos_empty": "Hozircha rasm yo'q",
    "photos_main": "Asosiy",
    "photos_set_main": "Asosiy qilish"
  },
  "checkout": {
    "items": "Mahsulotlar ({count})",
    "delivery": "Yetkazib berish",
    "free": "bepul",
    "discount": "Chegirma",
    "bonus": "Sovg'a",
    "promo_placeholder": "Promokod",
    "promo_applied": "qo'llanildi",
    "total": "Jami",
    "clear": "Tozalash",
    "page_title": "Buyurtmani rasmiylashtirish",
    "section_contact": "Aloqa ma'lumotlari",
    "section_delivery": "Olish usuli",
    "section_payment": "To'lov",
    "section_notes": "Buyurtmaga izoh",
    "name_label": "Qabul qiluvchining ismi",
    "phone_label": "Telefon",
    "phone_share_cta": "Telefon raqamini ulashish",
    "phone_unavailable": "Bu funksiya faqat Telegram ichida mavjud",
    "address_label": "Ko'cha, uy, kvartira",
    "address_placeholder": "Misal ko'chasi, 1-uy, 25-kvartira",
    "city_label": "Shahar",
    "city_placeholder": "Toshkent",
    "postal_label": "Indeks",
    "postal_placeholder": "100000",
    "pickup_select": "Olib ketish nuqtasini tanlang",
    "pickup_empty": "Olib ketish nuqtalari mavjud emas",
    "pickup_main_badge": "Asosiy",
    "notes_placeholder": "Buyurtmaga izohlar (ixtiyoriy)",
    "place_order": "Buyurtmani tasdiqlash",
    "placing": "Yuborilmoqda...",
    "order_created": "Buyurtma rasmiylashtirildi",
    "back_to_cart": "← Savatga",
    "continue_to_checkout": "Rasmiylashtirishga",
    "empty_cart": "Savat bo'sh",
    "err_required_name": "Qabul qiluvchining ismini kiriting",
    "err_required_phone": "Telefon raqamini kiriting",
    "err_required_pickup": "Olib ketish nuqtasini tanlang",
    "err_required_address": "Yetkazish manzilini kiriting",
    "err_required_city": "Shaharni kiriting",
    "order_summary": "Sizning buyurtmangiz",
    "section_date": "Yetkazish sanasi",
    "date_today": "Bugun",
    "date_tomorrow": "Ertaga",
    "date_change": "O'zgartirish",
    "recipient_me": "Men o'zim olaman",
    "recipient_other": "Boshqa odamga",
    "section_recipient": "Qabul qiluvchi ma'lumotlari",
    "recipient_fio_label": "Qabul qiluvchining FIO",
    "recipient_fio_placeholder": "Aliyev Aliy Aliyevich",
    "recipient_phone_label": "Qabul qiluvchining telefoni",
    "share_location_cta": "Geolokatsiyani ulashish",
    "location_hint": "Manzilni to'ldirgandan keyin tahrirlash mumkin",
    "address_map_hint": "Xaritada belgi qo'ying yoki manzilni yozing. Domofon/mo'ljal — buyurtma izohida.",
    "location_unavailable": "Bu funksiya faqat Telegram ichida mavjud",
    "payer_me": "Men to'layman",
    "payer_recipient": "Qabul qiluvchi to'laydi",
    "payer_hint": "To'lov usuli — naqd pul bilan qabul qilganda"
  },
  "profile": {
    "title": "Profil",
    "default_name": "Foydalanuvchi",
    "telegram_id": "Telegram ID",
    "language": "Til",
    "premium": "Premium",
    "platform": "Platforma",
    "sdk_version": "SDK versiyasi",
    "edit_name": "Ismni tahrirlash",
    "first_name": "Ism",
    "last_name": "Familiya",
    "save": "Saqlash",
    "saved": "Saqlandi",
    "share_phone": "Telefon raqamini ulashish",
    "phone_set": "Telefon saqlandi",
    "phone_empty": "Kiritilmagan",
    "phone_unavailable": "Bu funksiya faqat Telegram ichida mavjud",
    "share_location": "Joylashuvni ulashish",
    "location_set": "Joylashuv saqlandi",
    "location_empty": "Kiritilmagan",
    "location_unavailable": "Bu funksiya faqat Telegram ichida mavjud",
    "tg_source_note": "Avatar va ism Telegram akkauntidan olinadi. Bu yerda ularni o'zgartirishingiz mumkin.",
    "photo_bad_type": "Iltimos, rasm tanlang (JPEG, PNG yoki WebP)",
    "photo_too_large": "Fayl juda katta — maksimal 5 MB",
    "photo_uploaded": "Rasm muvaffaqiyatli yuklandi",
    "photo_upload_error": "Rasmni yuklab bo'lmadi",
    "about_store": "Do'kon haqida",
    "about_store_hint": "Manzil, aloqalar va yuridik ma'lumotlar",
    "menu_orders": "Buyurtmalarim",
    "menu_orders_hint": "Buyurtmalar tarixi va holati",
    "menu_addresses": "Mening manzillarim",
    "menu_addresses_hint": "Xaritada yetkazish manzili",
    "menu_favorites": "Sevimlilar",
    "menu_favorites_hint": "Saqlangan mahsulotlar",
    "menu_cart": "Savat",
    "menu_cart_hint": "Rasmiylashtirish uchun mahsulotlar",
    "menu_delivery": "Yetkazib berish va to'lov",
    "menu_delivery_hint": "Yetkazib berish shartlari va to'lov usullari",
    "menu_return": "Qaytarish va almashtirish",
    "menu_return_hint": "Mahsulotni qaytarish va almashtirish qoidalari",
    "menu_support": "Qo'llab-quvvatlash",
    "menu_support_hint": "Buyurtma bo'yicha biz bilan bog'laning",
    "menu_channel": "Kanalimizga o'tish",
    "menu_channel_hint": "Yangiliklar, kelishlar va yangilanishlar"
  },
  "contacts": {
    "title": "Do'kon haqida",
    "store_name": "Do'kon",
    "address": "Manzil",
    "open_in_maps": "Xaritada ochish",
    "copy_address": "Manzilni nusxalash",
    "copied": "✓ Nusxalandi",
    "copy_failed": "Nusxalab bo'lmadi",
    "support": "Qo'llab-quvvatlash xizmati",
    "phone": "Telefon",
    "email": "Elektron pochta",
    "telegram": "Telegram",
    "legal": "Yuridik ma'lumot",
    "legal_name": "Nomi",
    "legal_inn": "INN",
    "legal_address": "Yuridik manzil"
  },
  "splash": {
    "brand": "EUROSTYLE"
  },
  "pickup_code": {
    "show_to_courier": "Olib ketish nuqtasida kuryerga ko'rsating",
    "code_label": "Buyurtma kodi",
    "qr_alt": "Buyurtma QR-kodi",
    "scan_hint": "Kuryer QR-ni skaner qiladi yoki kodni qo'lda kiritadi — buyurtma yetkazilgan deb belgilanadi.",
    "invalid": "Noto'g'ri kod"
  },
  "addresses": {
    "title": "Mening manzillarim",
    "delivery_address": "Yetkazish manzili",
    "placeholder": "Shahar, ko'cha, uy",
    "save": "Saqlash",
    "saving": "Saqlanmoqda…",
    "saved": "Manzil saqlandi",
    "hint": "Xaritada belgi qo'ying yoki manzilni yozing. Domofon/mo'ljal — buyurtma izohida."
  },
  "orders": {
    "title": "Mening buyurtmalarim",
    "empty": "Hali buyurtmalar yo'q",
    "empty_hint": "Katalogdan birinchi buyurtmangizni bering"
  },
  "order": {
    "title": "Buyurtma #{short_id}",
    "not_found": "Buyurtma topilmadi",
    "status_new": "Yangi",
    "status_packed": "Yig'ilgan",
    "status_delivering": "Yetkazilmoqda",
    "status_delivered": "Yetkazildi",
    "status_partial": "Qisman yetkazildi",
    "status_cancelled": "Bekor qilindi",
    "delivery_pickup": "Olib ketish",
    "delivery_courier": "Kuryer",
    "address": "Yetkazish manzili",
    "pickup_point": "Olib ketish nuqtasi",
    "courier": "Kuryer",
    "open_in_maps": "Xaritada ochish",
    "call_phone": "Qo'ng'iroq qilish",
    "items_count": "{count} ta mahsulot",
    "subtotal": "Mahsulotlar",
    "shipping": "Yetkazish",
    "total": "Jami",
    "ordered_at": "{date} da rasmiylashtirilgan",
    "verified_at": "{date} da qabul qilingan",
    "delivery_code_hint": "Kodni kuryerga ko'rsating"
  },
  "courier": {
    "title": "Mening yetkazishlarim",
    "profile_hint": "Tayinlangan buyurtmalar va tasdiqlash",
    "code_label": "Mijozning olish kodi",
    "code_placeholder": "XXXXXXXX",
    "confirm": "Yetkazishni tasdiqlash",
    "confirming": "Tasdiqlanmoqda…",
    "confirmed": "Yetkazish tasdiqlandi ✓",
    "empty": "Tayinlangan yetkazishlar yo'q",
    "call": "Qo'ng'iroq",
    "maps": "Xaritada"
  },
  "returns": {
    "request": "Qaytarishni rasmiylashtirish",
    "requested_ok": "Qaytarish arizasi yuborildi",
    "reason_placeholder": "Qaytarish sababi (ixtiyoriy)",
    "ordered": "buyurtma: {count}",
    "submit": "Arizani yuborish",
    "sending": "Yuborilmoqda…",
    "reason": "Sabab",
    "approve": "Tasdiqlash",
    "reject": "Rad etish",
    "mark_received": "Qabul qilish (omborga)",
    "status_requested": "So'ralgan",
    "status_approved": "Tasdiqlangan",
    "status_received": "Qabul qilingan",
    "status_rejected": "Rad etilgan"
  },
  "errors": {
    "network": "Internet aloqasi yo'q. Internetni tekshiring.",
    "internal": "Nimadir xato ketdi. Qayta urinib ko'ring.",
    "db": "Ma'lumotlar bazasi xatosi.",
    "validation": "Ma'lumotlar noto'g'ri.",
    "forbidden": "Ruxsat berilmagan.",
    "not_found": "Topilmadi.",
    "banned": "Hisob bloklangan.",
    "no_user": "Foydalanuvchi topilmadi.",
    "init_data_invalid": "Telegram avtorizatsiyasi xatosi.",
    "init_data_missing": "Ilovani Telegram orqali oching.",
    "invalid_state": "Buyurtma holati noto'g'ri.",
    "storage": "Faylni yuklashda xato.",
    "invalid_file_type": "Fayl formati qo'llab-quvvatlanmaydi.",
    "invalid_file_size": "Fayl juda katta.",
    "invalid_phone": "Telefon raqami noto'g'ri.",
    "stock": "Omborda mahsulot yetarli emas."
  }
}
